(() => {
  // Adjust images sizes
  document
    .querySelectorAll(".article__content > p, .article__content > div")
    .forEach((item) => {
      if ([...item.children].every((child) => child.nodeName === "IMG")) {
        const width =
          100 / (item.children.length === 2 ? 2 : item.children.length / 2);
        const mod = item.children.length % 2 === 0;

        item.style.display = "flex";
        item.style.flexWrap = "wrap";
        item.style.gap = "1rem";

        [...item.children].forEach((child) => {
          child.style.flex = 1;
          if (mod) {
            child.style.width = `calc(${width}% - 0.5rem)`;
          }
        });
      }
    });

  // Swap tables with divs
  document.querySelectorAll(".article__content table").forEach((item) => {
    const mainDiv = document.createElement("div");
    mainDiv.classList.add("grid");
    item.querySelectorAll("td").forEach((td) => {
      const div = document.createElement("div");
      div.innerHTML = td.innerHTML;
      mainDiv.appendChild(div);
    });
    item.parentElement.insertBefore(mainDiv, item);
    item.remove();
  });
})();

// Newsletter widget
(() => {
  const newsletterWidget = document.querySelector(
    ".article__sidebar-widget--newsletter"
  );

  if (!newsletterWidget) {
    return;
  }

  if (document.documentElement.clientWidth < 1000) {
    const commentsHolder = document.querySelector("#comments");

    if (!commentsHolder) {
      return;
    }

    commentsHolder.parentElement.insertBefore(newsletterWidget, commentsHolder);
  }

  const collapsedHeight = "0";
  const readMoreButton = document.querySelector(
    ".article__sidebar-widget--newsletter > div"
  );
  const descriptionHolder = document.querySelector(
    ".article__sidebar-widget--newsletter > form"
  );

  if (!readMoreButton || !descriptionHolder) {
    return;
  }

  descriptionHolder.style.height = "auto";
  descriptionHolder.dataset.fullHeight = `${descriptionHolder.clientHeight}px`;
  descriptionHolder.style.height = collapsedHeight;

  function toggleDescription(evt) {
    if (descriptionHolder.clientHeight === 0) {
      descriptionHolder.style.height = descriptionHolder.dataset.fullHeight;
    } else {
      descriptionHolder.style.height = collapsedHeight;
    }
  }

  readMoreButton.addEventListener("click", toggleDescription);

  KlaviyoSubscribe.attachToForms(".article__sidebar-widget--newsletter form", {
    hide_form_on_success: true,
    extra_properties: {
      $source: "Footer",
      Brand: "Klaviyo",
    },
  });
})();

// Weird IG iframe behaviour on Safari
(() => {
  let interval = setInterval(() => {
    const frames = document.querySelectorAll(
      ".article__content iframe.instagram-media"
    );

    if (frames.length < 1) {
      return;
    }

    clearInterval(interval);

    frames.forEach((frame) => {
      frame.parentElement.style.display = "flex";
    });
  }, 100);
})();
